import { QuestionType } from '@webapp/common/resources/survey';

// Если список вопросов без репорта и без номера начнет отличаться, то разделить этот список на 2 (orders и reports)
export const IGNORED_QUESTIONS_TYPES = [QuestionType.TEXT_BLOCK, QuestionType.VIDEO_TEST, QuestionType.FIVE_SEC_TEST];

export const isOrderVisible = (type: QuestionType) => {
    return !IGNORED_QUESTIONS_TYPES.includes(type);
};

export const filterQuestionsWithoutReport = (reports) => {
    return reports.filter((item) => !IGNORED_QUESTIONS_TYPES.includes(item.type));
};

export const reorderQuestions = (questions, pages?: Array<{ ID: number; ORDER: number }>) => {
    let newOrder = 1;
    const pageOrder =
        pages && pages.length > 0 ? new Map(pages.map((page) => [Number(page.ID), Number(page.ORDER)])) : null;
    // API может вернуть вопросы в порядке импорта/создания, а не в порядке страниц.
    // Сначала раскладываем их по страницам, затем нумеруем сверху вниз.
    const ordered = pageOrder
        ? (questions || [])
              .map((question, index) => ({ question, index }))
              .sort((a, b) => {
                  const aPage = pageOrder.get(Number(a.question.PAGE)) ?? Number.MAX_SAFE_INTEGER;
                  const bPage = pageOrder.get(Number(b.question.PAGE)) ?? Number.MAX_SAFE_INTEGER;
                  if (aPage !== bPage) return aPage - bPage;
                  const aOrder = Number(a.question.ORDER);
                  const bOrder = Number(b.question.ORDER);
                  if (Number.isFinite(aOrder) && Number.isFinite(bOrder) && aOrder !== bOrder) {
                      return aOrder - bOrder;
                  }

                  return a.index - b.index;
              })
              .map(({ question }) => question)
        : questions || [];

    // Вопросы могут прийти пустыми/недогруженными — не роняем маппинг (FRONT-2ABX).
    return ordered.map(({ ORDER, ...item }) => {
        if (IGNORED_QUESTIONS_TYPES.includes(item.QUESTION_TYPE_ID)) {
            return { ...item };
        }

        return { ...item, ORDER: newOrder++ };
    });
};

export const QUESTIONS_EDITOR_PLACEHOLDER: { [type: string]: string } = {
    [QuestionType.TEXT_BLOCK]: 'Заголовок',
};
